<div class="panel" [class.panel--open]="isOpen">
  <button
    type="button"
    aria-hidden="true"
    tabindex="-1"
    class="panel__background"
    [class.panel__background--cart]="isCart"
    [attr.aria-label]="'a11y.design_system.modal.close_button' | translate"
    (click)="requestClose()"
  ></button>

  <div
    class="panel__container"
    [class.panel__container--cart]="isCart"
    [@slideInOut]="openTrigger"
    (@slideInOut.done)="onAnimationEvent($event)"
    *ngIf="isOpen"
  >
    <button (focus)="focusLastFocusable()" class="sr-only loop-focus">▼</button>

    <div class="panel__header" [class.panel__header--cart]="isCart">
      <button
        #closeButton
        app-vtmn-play-icon-button
        type="button"
        class="panel__close-button"
        [class.panel__background--cart]="isCart"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayIconButtonVariant.TERTIARY"
        [attr.aria-label]="'a11y.design_system.modal.close_button' | translate"
        (click)="requestClose()"
      >
        <vtmn-play-icon [name]="iconType?.Close"></vtmn-play-icon>
      </button>

      <div
        class="panel__title"
        [class.panel__title--cart]="isCart"
        *ngIf="panelTitle"
      >
        {{ panelTitle }}
        <ng-container *ngIf="hasHeaderContent">
          <ng-content select="[panel-header-content]"></ng-content>
        </ng-container>
      </div>
    </div>

    <div class="panel__content" [class.panel__content--cart]="isCart">
      <ng-content select="[panel-content]"></ng-content>
    </div>

    <div class="panel__footer" *ngIf="hasFooter" data-test="legal-mentions">
      <ng-content select="[panel-footer]"></ng-content>
    </div>

    <button (focus)="focusFirstFocusable()" class="sr-only loop-focus">
      ▲
    </button>
  </div>
</div>
